<template>
  <div class="settings-panel__container">
    <div class="setting-section">
      <p class="setting-section__h">Позиция</p>
      <div class="setting-row">
        <label>Тип</label>
        <p><u>Иконка</u></p>
      </div>
      <div class="setting-row">
        <label>ID</label>
        <p class="setting-row__p"><u>{{ internalValue.id }}</u></p>
        <button @click="copyId(internalValue.id)" class="modal-copy__button">
          <Icon
            svgClass="modal-copy__svg"
            name="copy"
            size="16"
          />
        </button>
      </div>
      <div class="setting-row">
        <button @click="deleteElement()" class="modal-delete__button">
          <Icon
            svgClass="modal-copy__svg"
            name="close"
            size="16"
          />
          Удалить
        </button>
      </div>
    </div>
    <div class="setting-section" v-if="internalValue">
      <p class="setting-section__h">Изображение</p>
      <div class="setting-column">
        <Upload
          :initialFiles="initialFiles"
          @update:selectedFiles="onSelectedFilesUpdate"
          :showDelete="true"
          :showSelect="false"
          :max-files="30"
        />
      </div>
    </div>

    <div class="setting-section">
      <p class="setting-section__h">Размеры</p>
      <div class="setting-row">
        <label class="label-row">Ширина</label>
        <InputComponent
          type="text"
          :model-value="responsiveSettings.width ?? defaultResponsive('width')"
          @update:model-value="val => updateResponsiveOrSetting('width', val)"
          suffix="rem"
          :min="0"
          :step="1"
          :max="150"
        />
      </div>

      <div class="setting-row">
        <label class="label-row">Высота</label>
        <InputComponent
          type="text"
          :model-value="responsiveSettings.height ?? defaultResponsive('height')"
          @update:model-value="val => updateResponsiveOrSetting('height', val)"
          suffix="rem"
          :min="0"
          :step="1"
          :max="150"
        />
      </div>

      <div class="setting-row">
        <label class="label-row">Минимальная ширина</label>
        <InputComponent
          type="text"
          :model-value="responsiveSettings.minWidth ?? defaultResponsive('minWidth')"
          @update:model-value="val => updateResponsiveOrSetting('minWidth', val)"
          suffix="rem"
          :min="0"
          :step="1"
          :max="150"
        />
      </div>

      <div class="setting-row">
        <label class="label-row">Минимальная высота</label>
        <InputComponent
          type="text"
          :model-value="responsiveSettings.minHeight ?? defaultResponsive('minHeight')"
          @update:model-value="val => updateResponsiveOrSetting('minHeight', val)"
          suffix="rem"
          :min="0"
          :step="1"
          :max="150"
        />
      </div>

      <div class="setting-row">
        <label class="label-row">Максимальная ширина</label>
        <InputComponent
          type="text"
          :model-value="responsiveSettings.maxWidth ?? defaultResponsive('maxWidth')"
          @update:model-value="val => updateResponsiveOrSetting('maxWidth', val)"
          suffix="rem"
          :min="0"
          :step="1"
          :max="150"
        />
      </div>

      <div class="setting-row">
        <label class="label-row">Максимальная высота</label>
        <InputComponent
          type="text"
          :model-value="responsiveSettings.maxHeight ?? defaultResponsive('maxHeight')"
          @update:model-value="val => updateResponsiveOrSetting('maxHeight', val)"
          suffix="rem"
          :min="0"
          :step="1"
          :max="150"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Upload from "@/components/UI/Upload/Upload.vue";
import InputComponent from '@/components/UI/Input/Input.vue';
import { safeClone } from '@/utils/clone.js';

function extractUrlFromCssBg(bg) {
  if (!bg || typeof bg !== 'string') return '';
  const m = bg.match(/url\((['"])?(.+?)\1\)/);
  return m ? m[2] : bg;
}

function normalizePayload(payload) {
  if (!Array.isArray(payload)) return [];
  return payload.map(p => {
    if (!p) return null;
    const url = p.url ?? p.src ?? p.preview ?? p.fileUrl ?? '';
    const name = p.name ?? p.filename ?? (url ? url.split('/').pop() : 'file');
    return { name, url, selected: p.selected === undefined ? true : !!p.selected };
  }).filter(Boolean);
}

export default {
  name: "ImageSettings",
  components: { Upload, InputComponent },
  props: {
    internalValue: { type: Object, required: true }
  },
  data() {
    return { selectedFiles: [] };
  },
  computed: {
    responsiveSettings() {
      const br = this.currentScreenSize;
      if (!this.internalValue || !this.internalValue.settings) return {};
      const resp = this.internalValue.settings.responsive;
      if (!resp || typeof resp !== 'object') return {};
      return (br && resp[br]) ? resp[br] : {};
    },
    initialFiles() {
    	let data = []
    	if(this.internalValue.settings?.hasOwnProperty('animation')) {
    		if(this.internalValue.settings.animation.data.length > 0)
	    		this.internalValue.settings.animation.data.forEach((item)=>{
	    			data.push({ name: 'slider-img', url: item, selected: true })
	    		})
    	}
      return data;
    },
    bgUrl() {
      return extractUrlFromCssBg(this.internalValue?.settings?.backgroundImage);
    }
  },
  watch: {
    internalValue: {
      immediate: true,
      handler(newVal) {
        if (!newVal) { this.selectedFiles = []; return; }
        const dataArray = Array.isArray(newVal.data) && newVal.data.length ? newVal.data : [];
        const bg = newVal?.settings?.backgroundImage;
      }
    }
  },
  methods: {
    copyId(text) { 
      if (!text) 
        return Promise.resolve(); 
        if (navigator.clipboard && window.isSecureContext) 
          return navigator.clipboard.writeText(text); 
          const ta = document.createElement('textarea'); 
          ta.value = text; 
          ta.style.position = 'fixed'; 
          ta.style.left = '-9999px'; 
          document.body.appendChild(ta); 
          ta.focus(); 
          ta.select(); 
          try { 
            document.execCommand('copy'); 
          } 
          catch(e) {} 
          document.body.removeChild(ta); return Promise.resolve(); 
    },
    updateResponsiveSetting(breakpointKey, prop, value) {
      const newVal = safeClone(this.internalValue || {});
      if (!newVal.settings) newVal.settings = {};
      if (!newVal.settings.responsive || typeof newVal.settings.responsive !== 'object') newVal.settings.responsive = {};
      if (!newVal.settings.responsive[breakpointKey] || typeof newVal.settings.responsive[breakpointKey] !== 'object') newVal.settings.responsive[breakpointKey] = {};

      const parsedValue = (value === null || value === undefined) ? undefined : value;
      if (parsedValue === undefined) {
        delete newVal.settings.responsive[breakpointKey][prop];
        if (Object.keys(newVal.settings.responsive[breakpointKey]).length === 0) delete newVal.settings.responsive[breakpointKey];
      } else {
        newVal.settings.responsive[breakpointKey][prop] = parsedValue;
      }

      if (newVal.settings.responsive && Object.keys(newVal.settings.responsive).length === 0) delete newVal.settings.responsive;

      this.emitUpdated(newVal);
    },
    emitUpdated(payload) {
      this.$emit('update:internal-value', safeClone(payload));
    },
    updateSetting(key, value) {
      const newVal = safeClone(this.internalValue || {});
      if (!newVal.settings) newVal.settings = {};
      if (value === null || value === undefined) delete newVal.settings[key];
      else newVal.settings[key] = value;
      this.emitUpdated(newVal);
    },
    updateResponsiveOrSetting(prop, value) {
      if (this.currentScreenSize) this.updateResponsiveSetting(this.currentScreenSize, prop, value);
      else this.updateSetting(prop, value);
    },
    defaultResponsive(prop) {
      return this.internalValue?.settings?.[prop] ?? '';
    },
    async deleteElement () {
      const id = this.internalValue?.id;
      if (!id) return;

      const ok = window.confirm('Удалить элемент и все его дочерние элементы?');
      if (!ok) return;

      try {
        await this.$store.dispatch('landing/DELETE_ELEMENT', id);
        try { this.$store.dispatch('activeElement/UPDATE_ACTIVE_ELEMENT', null); } catch(e){}
        try { this.$store.dispatch('choosedElement/UPDATE_CHOOSED_ELEMENT', null); } catch(e){}
        this.$emit('update:internal-value', null);
        // this.$emit('element-updated', null);
      } catch (err) {
        console.error('deleteElement failed', err);
      }
    },
    onSelectedFilesUpdate(payload) {
      const normalized = normalizePayload(payload);
      this.selectedFiles = normalized;

      const updated = { ...this.internalValue };
      const isImgTag = String((updated.tag || '')).toLowerCase() === 'img';
      const hadDataArray = Array.isArray(updated.data) && updated.data.length;

      if (isImgTag || hadDataArray) {
        updated.data = normalized;
      } else {
        if (!updated.settings) updated.settings = {};
        updated.settings.animation.data = []
        this.selectedFiles.forEach((item)=>{
        	updated.settings.animation.data.push(item.url)
        })
      }

      this.$emit('update:internal-value', updated);
    }
  }
};
</script>



<style scoped>
.setting-section { padding-bottom:0.5rem; margin-top:0.5rem; border-bottom:0.1rem solid var(--grey-0); display:flex; flex-direction:column; gap:0.5rem; }
.setting-row { display:flex; align-items:center; gap:0.5rem; }
.setting-column { display:flex; flex-direction:column; gap:0.5rem; width: 100%;}
.setting-section__h { text-align:start; font-weight:bold; }
.label-row {
  text-wrap: nowrap;
}
.modal-copy__svg {
  width: 1rem;
  height: 1rem;
}
.modal-copy__button {
  padding: 0;
  color: white;
  background-color: transparent;
  border: 0.1rem solid var(--color-0);
  padding: 0.2rem;
}
.setting-row__p {
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.modal-delete__button {
  padding: 0;
  color: white;
  background-color: transparent;
  border: 0.1rem solid var(--color-0);
  padding: 0.2rem;
}
</style>